import { inject, Service } from "@angular/core";

import { ConnectionItem, MainResponseModel } from "../models";
import { MainService } from "./main-service";

@Service()
export class ConnectionsApiService {
  private _mainService = inject(MainService);

  public getConnection(itemId: number, itemType: number, isHardLink: boolean = true) {
    return this._mainService.sendRequest<MainResponseModel<ConnectionItem>>({
      method: "GET",
      url: `connection/get?itemId=${itemId}&itemType=${itemType}&isHardLink=${isHardLink}`,
    });
  }

  public getAll(itemId: number, itemType: number) {
    return this._mainService.sendRequest<MainResponseModel<ConnectionItem>>({
      method: "GET",
      url: `connection/getAllHardByItem?itemId=${itemId}&itemType=${itemType}`,
    });
  }
}
